<template>
    <page>
        <module :title="id ? '编辑话题' : '新建话题'">
            <c-form ref="form">
                <c-form title="基础信息">
                    <c-form-item type="input" label="话题标题" name="title" required></c-form-item>
                    <c-form-item type="image" limit="6" label="话题图片" required name="img_list" file-word="最多可上传6张图片<br>建议尺寸：750X375px" ></c-form-item>
                    <c-form-item type="select" label="所属模块" name="classify" required options="CLASSIFY_TOPIC"></c-form-item>
                    <c-form-item type="textarea"  label="内容" name="content" required ></c-form-item>
                </c-form>


            </c-form>

            <template slot="button">
                <c-button v-show="editFlag" power="b_moments_topic_edit" size="m" @click="submit()">提交保存</c-button>
            </template>
        </module>

    </page>
</template>

<script>
    import productSelector from '@/components/service/product_selector.vue'
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from "vuex";

    export default {
        name: 'moments_topic_edit',

        components: {
        },

        computed: {
            ...mapState(['dict']),
        },

        props: {
            id: String
        },

        data() {
            return {

                editFlag: true,
            }
        },

        watch: {
            id() {
                this.getTagDetail();
            },

        },

        mounted() {
            this.id && this.getTagDetail();
        },

        methods: {
            getTagDetail() {
                this.request({
                    url: '/moments/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        data.img_list = data.media_list||[];
                        this.$refs.form.set(data);
                    }
                });
            },

            submit() {
                this.$refs.form.submit({
                    url: this.id ? '/moments/edit_topic' : '/moments/add_topic',

                    rule: {
                        title: '请填写话题名称',
                        classify: '请选择所属分类',
                        content: '请填写话题内容',

                    },

                    dataFormatter: data => {
                        this.id && (data.id = this.id);
                        return data;
                    },

                    success: (data,obj) => {
                        this.$message({
                            text: '保存成功'
                        });

                        this.$bus.$emit('momentsTopicList.update');
                        this.redirectTo('/moments_topic');
                    }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .limit {
    .item {
      margin-right: 16px;

      label {
        margin-right: 8px;
      }
    }
  }
</style>